import { useTranslation } from "react-i18next";

import type { ProjectStatistics_PlannerVisitFragment } from "../fragments.generated";
import { ProjectVisitListCard } from "./ProjectVisitListCard";

interface Props {
    visits: ProjectStatistics_PlannerVisitFragment[];
}

export function ProjectUpcomingVisitsCard({ visits }: Props) {
    const { t } = useTranslation("project");

    return (
        <ProjectVisitListCard
            href="planned"
            hrefTitle={t("overviewScreen.upcomingVisits.link")}
            title={t("overviewScreen.upcomingVisits.title")}
            visits={visits}
        />
    );
}
